import type { ReactElement, ReactNode } from 'react';
import { useRender } from '@base-ui/react/use-render';
import { EMPTY_VALUE } from '@/constants/app.constants';

const LINK_CLASS =
  'rounded text-left font-medium text-primary underline decoration-dotted underline-offset-2 hover:decoration-solid focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none';

interface DrillNameProps {
  value: string | null;
  label: string;
  render: ReactElement;
  highlightedValue?: ReactNode | undefined;
}

export function DrillName({ value, label, render, highlightedValue }: DrillNameProps) {
  const shownValue = value === null || value === '' ? EMPTY_VALUE : value;
  return useRender({
    defaultTagName: 'a',
    render,
    props: {
      'aria-label': label,
      className: LINK_CLASS,
      children: highlightedValue ?? shownValue,
    },
  });
}
